import emailjs from "@emailjs/browser";

export const emailjsSend = async (data, templateID) => {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICEID;
  const userId = process.env.REACT_APP_EMAILJS_USERID;

  if (!serviceId || !userId) {
    return {
      ok: false,
      error:
        'Email service is not configured. Please set REACT_APP_EMAILJS_SERVICEID and REACT_APP_EMAILJS_USERID.',
    };
  }

  try {
    await emailjs.send(serviceId, templateID, data, userId);
    return { ok: true };
  } catch (err) {
    console.error('EmailJS send failed', err);
    return { ok: false, error: err?.text || err?.message || 'Unknown error' };
  }
};
